module.exports = __webpack_public_path__ + "img/gb-nir.gb-niraec8ba2.svg";